// Standalone entry for the API docs page (/api/docs).
// It is NOT part of the React SPA — it boots only Swagger UI, so loading the docs
// page no longer triggers the app's startup calls (config, mbc, mitre, translations…).
import SwaggerUIBundle from 'swagger-ui-dist/swagger-ui-bundle.js'
import 'swagger-ui-dist/swagger-ui.css'

const ui = SwaggerUIBundle({
  url: '/openapi.json',
  dom_id: '#swagger-ui',
  presets: [SwaggerUIBundle.presets.apis, SwaggerUIBundle.SwaggerUIStandalonePreset],
  requestInterceptor: (req: { credentials: string }) => {
    // Send auth cookies so the backend filters the schema by the user's role.
    req.credentials = 'include'
    return req
  },
  onComplete: () => {
    // Dynamically set the title based on the openapi.json title.
    const title = ui.specSelectors.info().get('title')
    if (title) {
      document.title = `${title} - API Documentation`
    }
  },
})

addCloseButton()

/**
 * Adds a "Close" button top-left of the UI.
 */
function addCloseButton() {
  const observer = new MutationObserver(() => {
    if (!document.querySelector('.auth-wrapper')) {
      return
    }
    observer.disconnect()

    const swaggerUI = document.getElementsByClassName('swagger-ui')[0]
    const wrapper = document.createElement('div')
    wrapper.classList.add('wrapper')

    const button = document.createElement('button')
    button.id = 'close-button'
    button.classList.add('btn', 'cancel')
    button.innerHTML = 'Close'
    button.onclick = () => window.close()

    wrapper.append(button)
    swaggerUI.prepend(wrapper)
  })

  observer.observe(document.body, { childList: true, subtree: true })
}
